import { render } from "./PanelEmployee.vue?vue&type=template&id=acbb639e"
import script from "./PanelEmployee.vue?vue&type=script&lang=js"
export * from "./PanelEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__